document.addEventListener('DOMContentLoaded', function() {
    // Initialize: Check first input and show its content
    const firstInput = document.querySelector('.custom-subscription__tab-input input:first-child');
    if (firstInput) {
        firstInput.checked = true;
        firstInput.closest('.custom-subscription__tab').classList.add('active');
        
        const firstContentId = firstInput.id;
        const firstContentDiv = document.querySelector(`.subscription-frequency-content[data-id="${firstContentId}"]`);
        if (firstContentDiv) {
            firstContentDiv.style.display = 'flex';
        }
    }

    // Handle subscription frequency tab switching
    document.querySelectorAll('.custom-subscription__tab-input input').forEach(input => {
        input.addEventListener('change', function() {
            // Uncheck all other inputs
            document.querySelectorAll('.custom-subscription__tab-input input').forEach(otherInput => {
                if (otherInput !== this) {
                    otherInput.checked = false;
                }
            });
            
            // Remove active class from all tabs
            document.querySelectorAll('.custom-subscription__tab').forEach(tab => {
                tab.classList.remove('active');
            });
            
            // Add active class to clicked tab
            this.closest('.custom-subscription__tab').classList.add('active');
            
            // Hide all content divs
            document.querySelectorAll('.subscription-frequency-content, .regular-pricing-content').forEach(content => {
                content.style.display = 'none';
            });
            
            // Show content based on input id
            const inputId = this.id;
            const contentDiv = document.querySelector(`.subscription-frequency-content[data-id="${inputId}"], .regular-pricing-content[data-id="${inputId}"]`);
            if (contentDiv) {
                contentDiv.style.display = 'flex';
            }
        });
    });

    // Make entire subscription tab clickable to select the radio button
    document.querySelectorAll('.custom-subscription__tab').forEach(tab => {
        tab.addEventListener('click', function(e) {
            // Don't trigger if clicking directly on the radio input
            if (e.target.tagName === 'INPUT') {
                return;
            }
            
            const radio = this.querySelector('input[type="radio"]');
            if (radio) {
                radio.checked = true;
                // Trigger change event to update active state
                radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    });

    // Get the submit button
    const submitBtn = document.querySelector('button.product-form__submit.button.button--secondary.button--full-width');
    
    if (!submitBtn) {
        console.log('Submit button not found');
        return;
    }

    // Check if custom qty wrapper exists
    const hasCustomQty = document.querySelector('.custom-qty-inner-wrapper');

    // Initialize: set default radio button to checked (only if custom qty exists)
    if (hasCustomQty) {
        const defaultRadio = document.querySelector('.custom-input-qty-btn input[type="radio"]');
        if (defaultRadio && !defaultRadio.checked) {
            defaultRadio.checked = true;
            defaultRadio.closest('.custom-qty__item-outer-wrapper').classList.add('active-selected');
        }
    }

    // Function to add item to cart
    function addToCart(formData) {
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            console.log('Item added to cart:', data);
            // Optionally redirect or show success message
            // window.location.href = '/cart';
        })
        .catch(error => {
            console.error('Error adding to cart:', error);
            alert('Error adding item to cart. Please try again.');
        });
    }

    submitBtn.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Submit button clicked');
        
        let quantity;

        // Get quantity based on whether custom qty wrapper exists
        if (hasCustomQty) {
            // Get the selected radio button for quantity from custom qty
            const selectedRadio = document.querySelector('.custom-input-qty-btn input[type="radio"]:checked');
            
            if (!selectedRadio) {
                console.warn('No quantity selected');
                return;
            }

            // Get the quantity from the addqty attribute
            quantity = selectedRadio.getAttribute('addqty');
        } else {
            // Get quantity from regular quantity input
            const quantityInput = document.querySelector('input[name="quantity"][type="number"]');
            
            if (!quantityInput || !quantityInput.value) {
                console.warn('No quantity input found');
                return;
            }

            quantity = quantityInput.value;
        }

        // Get the selected subscription option
        const selectedSubscriptionRadio = document.querySelector('.custom-subscription__tab-input input:checked');
        const sellingPlanId = selectedSubscriptionRadio ? selectedSubscriptionRadio.getAttribute('data-selling-plan') : null;
        const isSubscription = selectedSubscriptionRadio && selectedSubscriptionRadio.id !== 'regular-price';

        if (quantity) {
            // Get the product form
            const productForm = submitBtn.closest('form') || document.querySelector('form[action*="/cart/add"]');
            
            if (!productForm) {
                console.error('Product form not found');
                return;
            }

            // Get the variant ID
            const variantInput = productForm.querySelector('input[name="id"]');
            const variantId = variantInput ? variantInput.value : null;

            if (!variantId) {
                console.error('Variant ID not found');
                return;
            }

            // Prepare cart data
            const cartData = {
                items: [{
                    id: variantId,
                    quantity: parseInt(quantity)
                }]
            };

            // Add selling plan if subscription is selected
            if (isSubscription && sellingPlanId) {
                cartData.items[0].selling_plan = sellingPlanId;
                console.log('Adding subscription to cart with selling plan:', sellingPlanId);
            } else {
                console.log('Adding one-time purchase to cart');
            }

            console.log('Adding to cart:', cartData);
            
            // Call the addToCart function
            addToCart(cartData);
        }
    });

    // Only attach custom qty event listeners if custom qty wrapper exists
    if (hasCustomQty) {
        // Make entire outer wrapper clickable to select the radio button
        document.querySelectorAll('.custom-qty__item-outer-wrapper').forEach(wrapper => {
            wrapper.addEventListener('click', function(e) {
                // Don't trigger if clicking directly on the radio input
                if (e.target.tagName === 'INPUT') {
                    return;
                }
                
                const radio = this.querySelector('input[type="radio"]');
                if (radio) {
                    radio.checked = true;
                    // Trigger change event to update active state
                    radio.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        });

        // Ensure only one radio button can be selected at a time
        document.querySelectorAll('.custom-input-qty-btn input[type="radio"]').forEach(radio => {
            radio.addEventListener('change', function() {
                if (this.checked) {
                    // Remove active class from all parent wrappers
                    document.querySelectorAll('.custom-qty__item-outer-wrapper').forEach(wrapper => {
                        wrapper.classList.remove('active-selected');
                    });
                    
                    // Add active class to the parent wrapper of the checked radio
                    this.closest('.custom-qty__item-outer-wrapper').classList.add('active-selected');
                    
                    // Uncheck all other radios
                    document.querySelectorAll('.custom-input-qty-btn input[type="radio"]').forEach(otherRadio => {
                        if (otherRadio !== this) {
                            otherRadio.checked = false;
                        }
                    });
                }
            });
        });
    } else {
        // Handle regular quantity input with plus/minus buttons
        const quantityInput = document.querySelector('input[name="quantity"][type="number"]');
        const minusBtn = document.querySelector('button.quantity__button[name="minus"]');
        const plusBtn = document.querySelector('button.quantity__button[name="plus"]');

        if (minusBtn) {
            minusBtn.addEventListener('click', function(e) {
                e.preventDefault();
                if (quantityInput) {
                    const currentValue = parseInt(quantityInput.value) || 1;
                    if (currentValue > 1) {
                        quantityInput.value = currentValue - 1;
                        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
            });
        }

        if (plusBtn) {
            plusBtn.addEventListener('click', function(e) {
                e.preventDefault();
                if (quantityInput) {
                    const currentValue = parseInt(quantityInput.value) || 1;
                    quantityInput.value = currentValue + 1;
                    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        }
    }
});